import styled from "styled-components";
import { Layout } from "antd";

export default styled(Layout)`
  background: var(--primary-color-dark);
`;